import { useEffect, useState, useCallback } from 'react';
import { userService } from '../service/instances';
import { OrganizationUnitChildItem } from '../component/organizationUnitDropdown/organizationUnitDropdown.type';

type UseInitialBranchEmailResult = {
  selectedBranch: OrganizationUnitChildItem | undefined;
  email: string;
  isLoading: boolean;
  setSelectedBranch: (branch: OrganizationUnitChildItem | undefined) => void;
  refetch: () => void;
};

export const useFetchBranchEmail = (): UseInitialBranchEmailResult => {
  const [selectedBranch, setSelectedBranch] = useState<
    OrganizationUnitChildItem | undefined
  >(undefined);
  const [email, setEmail] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchEmail = useCallback(async (branchId: string) => {
    try {
      setIsLoading(true);
      const response = await userService.getVenueBranchLoginUser(branchId);
      setEmail(response?.email || '');
    } catch {
      setEmail('');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const refetch = useCallback(() => {
    if (selectedBranch?.value) {
      fetchEmail(selectedBranch.value);
    }
  }, [selectedBranch, fetchEmail]);

  useEffect(() => {
    if (selectedBranch?.value) {
      fetchEmail(selectedBranch.value);
    } else {
      setEmail('');
    }
  }, [selectedBranch, fetchEmail]);

  return {
    selectedBranch,
    email,
    isLoading,
    setSelectedBranch,
    refetch,
  };
};
